$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};
jQuery(document).ready(function(){
	if(jQuery(window).width() > 768)
	{	
		var showStickyOffset = jQuery("#main-home-hero").outerHeight();
		jQuery(window).on("scroll", function(){
      var scroll = $(this).scrollTop();
			if(scroll >= showStickyOffset)
      {
      	jQuery('body.index .header-home__content').css("transform", "translateY(0px)");
        jQuery("header.header-home").addClass("sticky");
      }
      else
      {
      	jQuery("header.header-home").removeClass("sticky");
      }
    });
	}
}); 